// src/components/Admin/Dashboard/DonorsModal.tsx

import React, { useEffect } from "react";
import {
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
  Paper,
} from "@mui/material";
import DetailsModal from "./DetailsModal";
import { useDonors } from "../hooks/useDonors";

interface DonorsModalProps {
  open: boolean;
  onClose: () => void;
  token: string;
}

const DonorsModal: React.FC<DonorsModalProps> = ({ open, onClose, token }) => {
  const {
    donors,
    loading,
    error,
    loadDonors,
  } = useDonors();

  useEffect(() => {
    if (open) {
      loadDonors();
    }
  }, [open, loadDonors]);

  return (
    <DetailsModal open={open} onClose={onClose} title="All Donors">
      {loading ? (
        <CircularProgress />
      ) : error ? (
        <Typography color="error">{error}</Typography>
      ) : donors.length === 0 ? (
        <Typography>No donors available.</Typography>
      ) : (
        <TableContainer component={Paper}>
          <Table aria-label="donors table">
            <TableHead>
              <TableRow>
                <TableCell>First Name</TableCell>
                <TableCell>Last Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Total Donation</TableCell>
                <TableCell>Donations</TableCell>
                <TableCell>Created At</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {donors.map((donor) => (
                <TableRow key={donor.id}>
                  <TableCell>{donor.firstName}</TableCell>
                  <TableCell>{donor.lastName}</TableCell>
                  <TableCell>{donor.email}</TableCell>
                  <TableCell>{donor.totalDonations}</TableCell>
                  <TableCell>{donor.donationCount}</TableCell>
                  <TableCell>{new Date(donor.createdAt).toLocaleDateString()}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </DetailsModal>
  );
};

export default DonorsModal;
